/**
 * Parses a label value that might be a string or array 
 * and returns a string array
 */
export const parseLabelValue = (value: any): string[] => {
  if (!value) return [];
  
  // If it's already an array, return it
  if (Array.isArray(value)) return value;
  
  // If it's a string, try to parse it as JSON
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error('Error parsing labels:', e);
      return [];
    }
  }
  
  return [];
}; 